import { lazy } from 'react';

export const AuthForgotPasswordScreenLazy = lazy(async () => {
  const { AuthForgotPasswordRequestScreen } = await import('./auth-forgot-password-request.screen.tsx');
  return { default: AuthForgotPasswordRequestScreen };
});
